import React, { useContext, useMemo } from "react";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { useDocumentTitle } from "usehooks-ts";
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import { useLocation, useNavigate } from "react-router-dom";
import { NoodleModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { isHttpOK } from "nood-comp/src/net/xhr";
import { queryStringModifier } from "nood-comp/src/util/converters/converters";
import CampusView from "src/routes/orgs/campuses/CampusView";
import Campuses from "src/routes/orgs/campuses/Campuses";
import CampusEditor from "src/routes/orgs/campuses/CampusEditor";
import { msg } from "src/app/msg";
export default function CampusesIndex(props) {
  var _useLocation;
  useDocumentTitle(msg.title(msg.campus));
  var id = useURLParam('id');
  var modalCtx = useContext(NoodleModalContext);
  var navigate = useNavigate();
  var queryString = (_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.search;
  var items = useMemo(function () {
    return [{
      id: 'list',
      label: 'Campuses',
      icon: 'list',
      content: /*#__PURE__*/React.createElement(Campuses, null),
      queryString: {
        id: undefined
      }
    }, {
      id: 'add',
      label: 'Add',
      icon: 'plus',
      content: /*#__PURE__*/React.createElement(CampusEditor, null),
      queryString: {
        id: undefined
      }
    }, {
      id: 'view',
      label: 'View',
      icon: 'eye',
      show: id !== null,
      content: /*#__PURE__*/React.createElement(CampusView, null),
      queryString: {
        id: id
      }
    }, {
      id: 'edit',
      label: 'Edit',
      icon: 'edit-2',
      show: id !== null,
      content: /*#__PURE__*/React.createElement(CampusEditor, null),
      queryString: {
        id: id
      }
    }, {
      id: 'delete',
      label: 'Delete',
      icon: 'x',
      show: id !== null,
      __click: function __click(e) {
        modalCtx.__confirmDelete({
          entity: "Campus",
          endpoint: "/campus/".concat(id),
          __onAfterDelete: function __onAfterDelete(response) {
            if (isHttpOK(response)) {
              navigate(queryStringModifier({
                queryString: queryString,
                modifiers: {
                  "do": "list",
                  id: undefined
                }
              }));
            }
          }
        });
      }
    }];
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Campuses"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: items
  }));
}